import { Link } from "react-router-dom";

const COLUMNS = [
  {
    title: "Services",
    links: [
      { label: "Individual Tax Preparation", to: "/tax-services" },
      { label: "Business Tax Preparation", to: "/business-services" },
      { label: "Bookkeeping", to: "/business-services" },
      { label: "Tax Notices", to: "/tax-services#notices" },
      { label: "Prior-Year Returns", to: "/tax-services#prior-year" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Tax Document Checklist", to: "/resources#checklist" },
      { label: "FAQ", to: "/resources#faq" },
      { label: "Tax Resource Center", to: "/resources#articles" },
      { label: "Complexity Check", to: "/complexity" },
      { label: "Fee Calculator", to: "/pricing" },
      { label: "Refund Information", to: "/resources/after-return-is-efiled" },
    ],
  },
  {
    title: "Client Access",
    links: [
      { label: "Secure Portal", to: "/portal" },
      { label: "Upload Documents", to: "/portal" },
      { label: "Schedule Appointment", to: "/book" },
      { label: "New Client", to: "/get-started" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Our Standards", to: "/standards" },
      { label: "Contact", to: "/contact" },
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Terms of Use", to: "/terms" },
      { label: "Data Security", to: "/security" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-steel-border bg-steel-surface">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <div className="font-display text-xl font-bold tracking-[0.18em] text-steel-text">
              STEELE <span className="text-steel-brass">INDUSTRIES</span>
            </div>
            <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.3em] text-steel-muted">
              Tax Preparation & Accounting Services
            </p>
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-steel-secondary">
              Taxes, handled — and explained clearly. Secure document handling, electronic
              filing, and a process that keeps you informed from start to finish.
            </p>
          </div>
          {COLUMNS.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h4 className="font-mono text-[11px] uppercase tracking-[0.25em] text-steel-muted">{col.title}</h4>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className="text-sm text-steel-secondary transition-colors duration-300 hover:text-steel-text"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-16 flex flex-col gap-4 border-t border-steel-border/60 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-steel-muted">© 2026 Steele Industries. All rights reserved.</p>
          <p className="max-w-xl text-xs leading-relaxed text-steel-muted">
            Steele Industries provides tax preparation and accounting services. Information on this site is
            general in nature and is not tax advice for your specific situation.
          </p>
        </div>
      </div>
    </footer>
  );
}
